import sites from './data/sites.json'

import {
  qs
} from './imports/utils'

import * as THREE from 'three'

import gsap from 'gsap'

export default {
  props: {
    sites: {
      type: Array,
      required: false,
      default: () => {
        return sites
      }
    },
  },
  data() {
    return {
      isAnimating: false,
      prevSite: null,
      currentSite: 'all',
      active: null,
      threeReady: false,
      THREE: null,
      sprites: new Map(),
      trans: new Map(),
      ratioX: 2840,
      ratioY: 1419,
      vertex: 'varying vec2 vUv; void main() { vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 ); }',
      fragment: 'varying vec2 vUv; uniform sampler2D texture; uniform sampler2D texture2; uniform sampler2D disp; uniform float dispFactor; uniform float effectFactor; void main() { vec2 uv = vUv; vec4 disp = texture2D(disp, uv); vec2 distortedPosition = vec2(uv.x + dispFactor * (disp.r*effectFactor), uv.y); vec2 distortedPosition2 = vec2(uv.x - (1.0 - dispFactor) * (disp.r*effectFactor), uv.y); vec4 _texture = texture2D(texture, distortedPosition); vec4 _texture2 = texture2D(texture2, distortedPosition2); vec4 finalTexture = mix(_texture, _texture2, dispFactor); gl_FragColor = finalTexture; }'
    }
  },
  methods: {
    init() {
      this.scene = new THREE.Scene();

      this.camera = new THREE.OrthographicCamera(
        this.ratioX / -2,
        this.ratioX / 2,
        this.ratioY / 2,
        this.ratioY / -2,
        1,
        1000,
      );

      this.camera.position.z = 1;

      this.renderer = new THREE.WebGLRenderer({
        antialias: false,
        alpha: false,
      });

      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(this.ratioX, this.ratioY);
      this.$refs.canvas.appendChild(this.renderer.domElement);

      this.setup();
      this.animate();
    },
    setup() {
      const loader = new THREE.TextureLoader();
      loader.crossOrigin = '';

      this.sites.forEach((voice) => {
        loader.load(voice.image, (text) => {
          const texture = text;
          texture.magFilter = THREE.LinearFilter;
          texture.minFilter = THREE.LinearFilter;
          texture.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
          this.sprites.set(voice.name, texture);
        });
      });

      const disp = loader.load(`site/${process.env.MIX_TEMPLATE_FOLDER}/dist/images/displacement/dmap.jpg`);
      disp.wrapS = THREE.RepeatWrapping;
      disp.wrapT = THREE.RepeatWrapping;

      this.mat = new THREE.ShaderMaterial({
        uniforms: {
          effectFactor: {
            type: 'f',
            value: 0.1
          },
          dispFactor: {
            type: 'f',
            value: 0.0
          },
          texture: {
            type: 't',
            value: this.sprites.get('all')
            // value: texture1
          },
          texture2: {
            type: 't',
            value: this.trans.get('all')
            // value: texture2
          },
          disp: {
            type: 't',
            value: disp
          },
        },

        vertexShader: this.vertex,
        fragmentShader: this.fragment,
        transparent: true,
        opacity: 1.0,
      });

      const geometry = new THREE.PlaneBufferGeometry(
        this.ratioX,
        this.ratioY,
        1,
      );

      this.object = new THREE.Mesh(geometry, this.mat);

      this.resizeObject();

      this.scene.add(this.object);
    },
    animate() {
      this.rAnimate = requestAnimationFrame(this.animate);
      this.renderer.render(this.scene, this.camera);
    },
    resizeObject() {
      this.canvasAspect = this.ratioX / this.ratioY;

      const imageAspect = 2840 / 1419;

      let horizontalDrawAspect = imageAspect / this.canvasAspect;

      let verticalDrawAspect = 1;

      if (horizontalDrawAspect < 1) {
        verticalDrawAspect /= horizontalDrawAspect;
        horizontalDrawAspect = 1;
      }
      this.object.scale.x = horizontalDrawAspect;
      this.object.scale.y = verticalDrawAspect;
    },
    hover(siteName) {
      if (this.isAnimating) return;

      this.prevSite = this.currentSite;
      this.currentSite = siteName;

      if (this.prevSite === this.currentSite) return;

      if (this.prevSite !== siteName) {
        const newSprite = this.sprites.get(siteName);
        const oldSprite = this.sprites.get(this.prevSite) || this.trans.get(siteName);

        if (siteName) {
          this.$el.querySelector('.canvas-wrapper canvas').classList.add('active')
        } else {
          this.$el.querySelector('.canvas-wrapper canvas').classList.remove('active')
        }

        this.mat.uniforms.texture = {
          type: 't',
          value: newSprite,
        };

        this.mat.uniforms.texture2 = {
          type: 't',
          value: oldSprite,
        };

        gsap.fromTo(this.mat.uniforms.dispFactor, 1.6, {
          value: 1,
          // ease: Expo.easeOut,
        }, {
          value: 0,
          // ease: Expo.easeOut,
        });
      }
    },
    addEvents() {
      this.ratioX = qs('.categories-banner').getBoundingClientRect().width;
      this.ratioY = qs('.categories-banner').getBoundingClientRect().height;
      this.renderer.setSize(this.ratioX, this.ratioY);
      this.resizeObject();
    },
  },
  mounted() {
    window.addEventListener('resize', this.addEvents, {
      passive: true
    });

    this.ratioX = qs('.categories-banner').getBoundingClientRect().width;
    this.ratioY = qs('.categories-banner').getBoundingClientRect().height;
    this.init();
  },
  beforeDestroy() {
    THREE = null;
    window.cancelAnimationFrame(this.rAnimate);
    window.removeEventListener('resize', this.addEvents);
  },
}